export enum CacheLocation {
  Memory = 'memory',
  LocalStorage = 'localstorage',
  SessionStorage = 'sessionstorage',
  NoCache = 'nocache',
}
